import React from 'react';
import { Alert } from '@mui/material';
import { CircleRounded as CircleRoundedIcon } from '@mui/icons-material';

// interfaces, styles
import type { MessageListProps } from 'interfaces';
import { StyledMessageList } from 'styles/commonComponentStyle';

export const MessageList: React.FC<MessageListProps> = ({ messages }) => {
  if (!Array.isArray(messages) || messages.length === 0) {
    return null;
  }

  return (
    <StyledMessageList>
      {messages.map((msg, idx) => (
        <Alert key={idx} severity="info" icon={<CircleRoundedIcon fontSize="inherit" />} variant="outlined">
          {msg}
        </Alert>
      ))}
    </StyledMessageList>
  );
};
